<template>
    <div class="tree_box hiddren_el_btscroll">
        <el-scrollbar style="height:100%;">
            <el-tree
                ref="tree"
                :data="treedata"
                :show-checkbox="showCheckbox"
                node-key="id"
                highlight-current
                :default-expanded-keys="openKey"
                :default-checked-keys="selectedData"
                @node-click="handleNodeClick"
                @check="getSelectedNode"
                :props="defaultprops">
                <span class="custom-tree-node" slot-scope="{ node, data }" @mouseenter="showOperations(data)" @mouseleave="showOperations">
                    <!-- <i class="el-icon-tickets" v-if="data[defaultprops.children]"></i> -->
                    <!-- <i class="el-icon-edit" v-else></i> -->
                    <i class="el-icon-tickets" v-if="data.layer == '1'"></i>
                    <i class="el-icon-document" v-if="data.layer == '2'"></i>
                    <!-- <i class="el-icon-edit" v-if="data.layer == '3'"></i> -->
                    <span>{{ data.menuDirName || data.menuName || data.btnName || node.label}}</span>
                    <span  v-if="showOperation || data.showNode" v-for="tevent in treesEvents" v-show="operationId === data.id">
                        <el-button v-if="tevent.type === 'add'" v-show="data[defaultprops.children]" size="mini" class="tree_button" icon="el-icon-plus" circle @click.stop="tevent.event(data)"></el-button>
                        <el-button v-if="tevent.type === 'edit'" content="编辑" size="mini" class="tree_button" style="border:0;color:#458FD9" icon="el-icon-document" circle @click.stop="tevent.event(data)"></el-button>
                        <el-button v-if="tevent.type === 'del'" content="删除" size="mini" class="tree_button" style="border:0;color:red;" icon="el-icon-delete" circle @click.stop="tevent.event(data)"></el-button>
                    </span>
                </span>
            </el-tree>
        </el-scrollbar>
    </div>
</template>

<script>
export default {
    name:'vTree',
    props:{
        data:{//所有数据
            type:Array,
            default:function(){
                return []
            }
        },
        selectedData:{//勾选的数据的id数组
            type:Array,
            default:function(){
                return []
            }
        },
        defaultprops:{//默认展开的子节点和显示字段
            type:Object,
            default:function(){
                return {
                    children: 'sysMenus',
                    label: 'menuDirName'
                }
            }
        },
        openKey:{//默认展开的id数组
            type:Array,
            default:function(){
                return []
            }
        },
        treesEvents:{//节点事件
            type:Array,
            default:function(){
                return []
            }
        },
        showCheckbox:{//是否显示勾选框checkbox
            type:Boolean,
            default:false
        },
        showOperation:{//是否显示节点操作按钮
            type:Boolean,
            default:false
        }
    },
    data(){
        return {
            operationId:'-1',
            treedata: this.data || [],
            treeDefData:[]
        }
    },
    watch:{
        data:{
            handler:function(val){
                this.treedata = val;
            },
            deep:true
        },
        selectedData:function(val){
            this.$refs.tree.setCheckedKeys([]);
            this.treeDefData = val;
        }
    },
    mounted() {
    },
    computed:{
    },
    methods:{
        getSelectedNode(data){//选中触发事件
            this.$emit('checkedKeys',this.$refs.tree.getCheckedKeys(true))
        },
        handleNodeClick(data){//点击节点触发事件
            this.$emit('handleNodeClick',data);
        },
        showOperations(data){
            if(data){
                this.operationId = data.id;
            }else{
                this.operationId = -1;
            }
        }
    }
}
</script>

<style scoped>
.tree_box{
    width: 100%;
}
.tree_button{
    width:18px;
    height:18px;
    line-height:18px;
    padding:0;
    text-align:center;
    margin: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/tree.vue